import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentDetailRoute } from './-route-wrappers';

function BroadcastTestsExperimentRoute() {
  const { broadcastId, experimentId } = Route.useParams();
  return <CampaignExperimentDetailRoute campaignId={broadcastId} experimentId={experimentId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/experiments/$experimentId',
)({
  component: BroadcastTestsExperimentRoute,
});
